import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {AnalysisKey, SearchResult, PreviousAnalysis} from '../../../model/analysis-details.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {MatSortModule} from '@angular/material/sort';
import { I } from '@angular/cdk/keycodes';


@Component({
    selector: 'app-show-table',
    templateUrl: './show-table.component.html',
    styleUrls: ['./show-table.component.scss'],
    standalone: false
})
export class ShowTableComponent implements OnInit {
  @ViewChild('RApaginator', {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  dataSource: MatTableDataSource<AnalysisKey>;
  tableColumns: string[] = ['fileName', 'analysisDate', 'status', 'projectCode'];
  reportAnalysis: AnalysisKey[] = [];

  @Input() searchResults: AnalysisKey[] = [];
  count: number;

  constructor() {}

  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.searchResults);
    setTimeout(() => this.dataSource.paginator = this.paginator);
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'analysisDate': return new Date(item.analysisDate);
        default: return item[property];
      }
    }
    setTimeout(() => this.dataSource.sort = this.sort);
    for (const result of this.searchResults) {
        this.reportAnalysis.push(result);
    }
    this.dataSource = new MatTableDataSource(this.reportAnalysis);
    setTimeout(() => this.dataSource.paginator = this.paginator);
    setTimeout(() => {this.dataSource.sort = this.sort});
  }

  getUrl(analysisType: string) {
    if (analysisType === 'AP') {
      return '/default-layout/molecule-analysis';
    } else {
      return '/default-layout/notfound';
    }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
